import Q from 'q';
import _ from 'underscore';
import get_query_string_object from 'nllib/src/uri/get_query_string_object';
import set_token from 'nllib/src/model/set_token';

export default {
    components: {},
    data() {
        return {}
    },
    methods: {},
    created() {
        const __this = this;

        const aQueryStringObject = get_query_string_object({
            isLowerCase: true,
        });
        console.log(aQueryStringObject);

        const token = aQueryStringObject.token;
        if (!token) {
            const msg = 'redirect parameter error, code=001';
            console.error(msg);
            return;
        }

        set_token({
            token: token,
        });

        const redirectType = aQueryStringObject.redirecttype;
        switch (redirectType) {
            case `000`:
            default:
                __this.$router.replace({
                    name: `admin-home`,
                });
                break;
        }
    },
    mounted() {
        // const __this = this;
    },
    activated() {
        // const __this = this;
    },
    deactivated() {
        // const __this = this;
    },
}
